import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useUpdateFolders = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();

  return useMutation(
    trpc.studysets.updateFolders.mutationOptions({
      onSuccess: (_, { id: studySetId }) => {
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getUserFolders.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getStudySets.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.getFolders.queryKey({ id: studySetId }),
        });
        toast.success("Moved successfully");
      },
      onError: (error) => {
        console.error("Failed to move folder", error);
        toast.error(error.message);
      },
    }),
  );
};
